// extracted by mini-css-extract-plugin
export default {"leftAvatar":"style_leftAvatar__s96bq"};